import styled from "styled-components";
import { useState } from "react";

import Overlay from "../Overlay";
import Modal from "../Utils/Modal";
import useApi from "../../hooks/useApi";

const Titulo = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #333;
    text-align: center;
`;
const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
`;
const BotoesWrapper = styled.div`
    margin-top: 35px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;
const Botao = styled.button`
    padding: 9px 12px;
    background-color: ${(props) => (props.cancel ? '#e5e7eb' : '#dc2626')};
    color: ${(props) => (props.cancel ? '#333' : 'white')};
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.2s all ease;
    &:hover {
        background-color: ${(props) => (props.cancel ? '#d1d5db' : '#b91c1c')};
    }
    &:disabled {
        background-color: ${(props) => (props.cancel ? '#e5e7eb' : '#fca5a5')};
        cursor: auto;
    }
`;

const ConfirmDeleteEmailTransferencia = ({ id, fecharModal, onDelete }) => {

    const api = useApi();
    const [saving, setSaving] = useState(false);

    const handleDelete = async () => {

        setSaving(true);

        try {

            await api.post(`/Painel/API/Transferencia/DeleteEmail/index.php?id=${id}`);

            await onDelete();
            fecharModal();

        } catch (err) {

            console.log(err);
            alert('Erro ao excluir e-mail.');

        } finally {

            setSaving(false);

        }

    };

    return (
        <Overlay state={true}>
            <Modal size="sm">
                <Titulo>Confirmar exclusão</Titulo>
                <Subtitulo>Tem certeza que deseja excluir este e-mail?</Subtitulo>
                <BotoesWrapper>
                    <Botao cancel onClick={fecharModal} disabled={saving}>
                        CANCELAR
                    </Botao>
                    <Botao onClick={handleDelete} disabled={saving}>
                        EXCLUIR
                    </Botao>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    );

};

export default ConfirmDeleteEmailTransferencia;
